import {
  FaCheck,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaClock,
  FaGoogle,
  FaFacebook,
  FaInstagram,
  FaTwitter,
  FaXTwitter,
  FaLinkedin,
  FaYoutube,
  FaTiktok,
  FaYelp,
  FaBlogger,
  FaMedium,
  FaWordpress,
  FaStar,
  FaLightbulb
} from 'react-icons/fa';

const iconMap = {
  Check: FaCheck,
  Phone: FaPhone,
  Email: FaEnvelope,
  Address: FaMapMarkerAlt,
  Hours: FaClock,
  Google: FaGoogle,
  Facebook: FaFacebook,
  Instagram: FaInstagram,
  Twitter: FaTwitter,
  XTwitter: FaXTwitter,
  LinkedIn: FaLinkedin,
  YouTube: FaYoutube,
  TikTok: FaTiktok,
  Blogger: FaBlogger,
  Medium: FaMedium,
  WordPress: FaWordpress,
  Yelp: FaYelp,
  Star: FaStar,
  Lightbulb: FaLightbulb,
};

const getIcon = (name) => iconMap[name] || FaCheck; // default to FaCheck if no match found
export { getIcon };
